module.exports = __webpack_public_path__ + "static/pantry-info-last-updated-sep-2021-d807e0d020414df65715121a516e4c9a.jpg";